/**
 * Using for recomendation products and recent view products
 */
if (!customElements.get('product-slider')) {
  customElements.define(
    'product-slider',
    class extends HTMLElement {
      connectedCallback() {
        this.wrap = this.querySelector('.products-grid-wrap');
        this.products = this.querySelector('.products-grid');
        this.enableSlider = this.dataset.enableSlider === 'true';

        if (!this.enableSlider || !this.wrap || !this.products) return;

        this.fixQuickviewDuplicate();

        this.wrap.classList.add('fc-native-slider');
        this.wrap.classList.remove('swiper');
        this.products.classList.remove('swiper-wrapper');
        this.products.classList.add('f-grid');
        this.wrap.style.setProperty('--fc-cols-md', this.dataset.tabletItems || '2');
        this.wrap.style.setProperty('--fc-cols-lg', this.dataset.items || '4');

        const scroller = this.wrap;
        const prev = this.querySelector('.swiper-button-prev');
        const next = this.querySelector('.swiper-button-next');
        const pag = this.querySelector('.swiper-pagination');
        let fill = null;
        if (pag) {
          pag.classList.add('swiper-pagination-progressbar', 'swiper-pagination-horizontal');
          fill = document.createElement('span');
          fill.className = 'swiper-pagination-progressbar-fill';
          pag.appendChild(fill);
        }
        const step = () => Math.max(scroller.clientWidth * 0.9, 240);

        function updateBar() {
          if (!fill) return;
          const max = scroller.scrollWidth - scroller.clientWidth;
          const progress = max > 0 ? scroller.scrollLeft / max : 0;
          const thumb = 0.5;
          fill.style.transform = 'translateX(' + (progress * (1 - thumb) * 100) + '%) scaleX(' + thumb + ')';
        }

        if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', (e) => { e.preventDefault(); scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
        scroller.addEventListener('scroll', updateBar, { passive: true });
        updateBar();
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) modal.remove();
          else modalIds.push(modalID);
        });
      }
    }
  );
}
